/*
  Configurador de cordones para la variante "A tu gusto" del pack.
  Se muestra solo cuando la variante activa del producto coincide con
  data-trigger-variant-id, guarda la eleccion como line item properties
  (inputs radio asociados al form del tema via atributo form) y expone
  una API (isActive / getProperties / reportValidity) para que otros
  botones de compra custom (p. ej. el bloque cork_atc) puedan validar
  e incluir las properties.
*/
(() => {
  if (typeof customElements.get('cork-cord-picker') !== 'undefined') return;

  class CorkCordPicker extends HTMLElement {

    connectedCallback() {
      if (this.dataset.corkReady === 'true') return;
      this.dataset.corkReady = 'true';

      this.groups = Array.from(this.querySelectorAll('[data-cork-cord-group]'));
      this.productPage = this.closest('[data-js-product-component]');
      this.picker = this.productPage && this.productPage.querySelector('product-variants[data-main-product-variants]');

      this.addEventListener('change', event => {
        const input = event.target.closest('[data-cork-cord-input]');
        if (!input) return;
        const group = input.closest('[data-cork-cord-group]');
        if (!group) return;
        const selected = group.querySelector('[data-cork-cord-selected]');
        if (selected) selected.textContent = input.value;
        this._toggleRequiredMessage(group, false);
      });

      if (this.picker) {
        this.picker.addEventListener('VARIANT_CHANGE', () => {
          window.requestAnimationFrame(() => this._update());
        });
        // Solo sincroniza si el picker ya conoce la variante; si no,
        // se respeta el estado renderizado en servidor.
        if (this.picker.currentVariant && this.picker.currentVariant.id) {
          this._update();
        }
      }
    }

    _update() {
      const variant = this.picker && this.picker.currentVariant;
      const active = !!(variant && variant.id && String(variant.id) === this.dataset.triggerVariantId);
      this.hidden = !active;
      this.querySelectorAll('[data-cork-cord-input]').forEach(input => {
        input.disabled = !active;
        input.required = active;
      });
      // El boton de pago dinamico (Shop Pay) se salta la validacion de
      // properties, asi que se oculta mientras el configurador esta activo.
      if (this.productPage) {
        this.productPage.querySelectorAll('.shopify-payment-button').forEach(button => {
          button.style.display = active ? 'none' : '';
        });
      }
      if (!active) {
        this.groups.forEach(group => this._toggleRequiredMessage(group, false));
      }
    }

    _toggleRequiredMessage(group, show) {
      const message = group.querySelector('.product-variant__required');
      if (message) message.style.display = show ? 'block' : 'none';
    }

    isActive() {
      return !this.hidden;
    }

    getProperties() {
      const properties = {};
      if (!this.isActive()) return properties;
      this.querySelectorAll('[data-cork-cord-input]:checked').forEach(input => {
        const match = input.name.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = input.value;
      });
      return properties;
    }

    reportValidity() {
      if (!this.isActive()) return true;
      let valid = true;
      this.groups.forEach(group => {
        if (!group.querySelector('[data-cork-cord-input]:checked')) {
          valid = false;
          this._toggleRequiredMessage(group, true);
        }
      });
      if (!valid && typeof this.scrollIntoView === 'function') {
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return valid;
    }

  }

  customElements.define('cork-cord-picker', CorkCordPicker);
})();
